import { render, staticRenderFns } from "./SuspiciousActivityReviewContainer.vue?vue&type=template&id=74deb659&"
import script from "./SuspiciousActivityReviewContainer.vue?vue&type=script&lang=js&"
export * from "./SuspiciousActivityReviewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports